import { useField } from '@/js/libs/final-form/index.ts';
export const useFieldValue = (fieldName) => {
    const { input: { value }, } = useField(fieldName, { subscription: { value: true } });
    return value;
};
